export default __webpack_public_path__ + "static/media/sadFace.c0d4f949.svg";